import cavatappi from '../images/jordan_portachiavi.jpg'

import borraccia_mensola from '../images/borraccia_inter_menola.png'
import borraccia_tappo from '../images/borraccia_tappo_inter.png'
import borraccia_etichetta from '../images/borraccia_etichetta.png'

export const prices = [
    {
        disp: 'none',
        type: 'simple',
        displays: cavatappi,
        product_title: 'Incidi su Iqos',
        main_alt: 'iqos',
        main_description: 'Personalizza le tua Iqos',
        price: '15',
    },

    {
        disp: 'none',
        type: 'complex',
        product_title: 'Incidi le chiavi per non confonderle più nel mazzo',
        main_img: '#',
        main_alt: 'chiavi',
        main_description: 'Senza più tag di plastica sbiaditi e rotti',
        small_img_1: '#',
        alt_img_1: '#',
        secondary_description_1: 'Chiara e precisa',
        small_img_2: '#',
        alt_img_2: '#',
        secondary_description_2: 'Resistente al tempo',
        price: '2€ x chiave',
    },

    {
        disp: 'none',
        type: 'simple',
        displays: cavatappi,
        product_title: 'Crea il tuo Zippo',
        main_alt: 'Zippo',
        main_description: 'I tuoi disegni per ogni tuo Zippo',
        price: '15',
    },

    {
        type: 'complex',
        product_title: 'Personalizza la tua borraccia',
        main_img: borraccia_mensola,
        main_alt: 'borraccia',
        main_description: 'La tua borraccia, il tuo design',
        small_img_1: borraccia_tappo,
        alt_img_1: 'tappo',
        secondary_description_1: 'Precisione per ogni disegno',
        small_img_2: borraccia_etichetta,
        alt_img_2: 'basta etichette',
        secondary_description_2: 'Non più scotch o etichette che rovinano e saltano via',
        price: 'Da 15€',
    },

    {
        disp: 'none',
        type: 'simple',
        displays: cavatappi,
        product_title: 'Realizza tutti i tuoi portachiavi',
        main_alt: 'Zippo',
        main_description: 'Infiniti portachiavi per tenere insieme tutto ciò di più importante',
        price: '15',
    },
]